import {
  // fleet category
  FETCH_FLEET_CATEGORY_DONE,
  FETCH_FLEET_CATEGORY_LOADING,
  FETCH_FLEET_CATEGORY_ERROR,
  // fleet type
  FETCH_FLEET_TYPE_DONE,
  FETCH_FLEET_TYPE_LOADING,
  FETCH_FLEET_TYPE_ERROR,
  // origin customer  
  FETCH_ORIGIN_CUSTOMER_DONE,
  FETCH_ORIGIN_CUSTOMER_LOADING,
  FETCH_ORIGIN_CUSTOMER_ERROR,
  // destination customer  
  FETCH_DESTINATION_CUSTOMER_DONE,
  FETCH_DESTINATION_CUSTOMER_LOADING,
  FETCH_DESTINATION_CUSTOMER_ERROR
} from './actions'

export default {
  [FETCH_FLEET_CATEGORY_LOADING] (state) {
    state.isLoadingFleetCategory = true
  },
  [FETCH_FLEET_CATEGORY_DONE] (state, items) {
    state.fleetCategory = items
    state.isLoadingFleetCategory = false
  },
  [FETCH_FLEET_CATEGORY_ERROR] (state, error) {
    state.errorFleetCategory = error
    state.isLoadingFleetCategory = false
  },
  [FETCH_FLEET_TYPE_LOADING] (state) {
    state.isLoadingFleetType = true
  },
  [FETCH_FLEET_TYPE_DONE] (state, items) {
    state.fleetType = items
    state.isLoadingFleetType = false
  },
  [FETCH_FLEET_TYPE_ERROR] (state, error) {
    state.errorFleetType = error
    state.isLoadingFleetType = false
  },
  [FETCH_ORIGIN_CUSTOMER_LOADING] (state) {
    state.isLoadingOriginCustomer = true
  },
  [FETCH_ORIGIN_CUSTOMER_DONE] (state, items) {
    state.originCustomer = items
    state.isLoadingOriginCustomer = false
  },
  [FETCH_ORIGIN_CUSTOMER_ERROR] (state, error) {
    state.errorOriginCustomer = error
    state.isLoadingOriginCustomer = false
  },
  [FETCH_DESTINATION_CUSTOMER_LOADING] (state) {
    state.isLoadingDestinationCustomer = true
  },
  [FETCH_DESTINATION_CUSTOMER_DONE] (state, items) {
    state.destinationCustomer = items
    state.isLoadingDestinationCustomer = false
  },
  [FETCH_DESTINATION_CUSTOMER_ERROR] (state, error) {
    state.errorDestinationCustomer = error
    state.isLoadingDestinationCustomer = false
  } 
}



// WEBPACK FOOTER //
// ./src/store/modules/tms/mutations.js